import { fetchTripLocations } from "modules/trips/api";
import React, { useEffect, useState } from "react";
import GoogleMapRoute from "../Summary/GoogleMapRoute";

const LiveLocation = ({ id }) => {
    const [tripData, setTripData] = useState({
        coordinates: [],
    });
    const [activeMarker, setActiveMarker] = useState(null);

    const handleActiveMarker = (marker) => {
        setActiveMarker(marker);
    };

    const getTripLocations = () => {
        fetchTripLocations(id, true).then((res) => {
            const response = res;

            // Process LineString features for segments
            const segments = response?.features
                ?.filter((feature) => feature.geometry?.type === "LineString")
                ?.map((feature) => ({
                    coordinates: feature.geometry.coordinates.map((item) => ({
                        lat: +item[1],
                        lng: +item[0],
                    })),
                    distanceType: feature.properties?.distance_type || null,
                }));

            // Process Point features for pins
            const pins = response?.features
                ?.filter((feature) => feature.geometry?.type === "Point")
                ?.map((feature) => ({
                    lat: +feature.geometry.coordinates[1],
                    lng: +feature.geometry.coordinates[0],
                    properties: feature.properties || {},
                }));

            setTripData({
                segments: segments || [],
                pins: pins || [],
            });
        });
    };

    useEffect(() => {
        getTripLocations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return (
        <GoogleMapRoute
            containerElement={{ height: "500px" }}
            isOpen
            tripData={tripData}
            activeMarker={activeMarker}
            handleActiveMarker={handleActiveMarker}
        />
    );
};

export default LiveLocation;
